import env from './env.js';

export const getApiUri = (browserHostname = window.location.hostname) => {
  if (browserHostname.includes('bybeam.co')) {
    return `//${browserHostname.replace('app', 'api')}/rental-assistance`;
  }
  return env().REACT_APP_API_URL;
};
